import React from 'react'
import { SvgIcon, SvgIconProps } from '@material-ui/core'

import { ReactComponent as FileSVG } from 'assets/images/file-icon.svg'

const FileIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props}>
    <FileSVG />
  </SvgIcon>
)

export default FileIcon
